import 'svgxuse';
import 'intersection-observer';
import {debounce} from 'debounce';

import {
    $,
    addClass,
    removeClass,
    hasClass,
    toggleClass,
    attr,
    removeAttr,
    data,
    transform,
    transition as transition$1,
    on,
    off,
    trigger,
    transitionEnd as transitionEnd$1,
    outerWidth,
    outerHeight,
    offset,
    css,
    each,
    html,
    text,
    is,
    index,
    eq,
    append,
    appendTo,
    prepend,
    next,
    nextAll,
    prev,
    prevAll,
    parent,
    parents,
    closest,
    find,
    children,
    remove,
    add,
    styles
} from 'dom7/dist/dom7.modular';

const Methods = {
    addClass,
    removeClass,
    hasClass,
    toggleClass,
    attr,
    removeAttr,
    data,
    transform,
    transition: transition$1,
    on,
    off,
    trigger,
    transitionEnd: transitionEnd$1,
    outerWidth,
    outerHeight,
    offset,
    css,
    each,
    html,
    text,
    is,
    index,
    eq,
    append,
    appendTo,
    prepend,
    next,
    nextAll,
    prev,
    prevAll,
    parent,
    parents,
    closest,
    find,
    children,
    remove,
    add,
    styles,
};

Object.keys(Methods).forEach((methodName) => {
    $.fn[methodName] = Methods[methodName];
});


window.$ = $;
window.axios = require('axios');

let modals = require('./modals.js');
let LazyLoad = require('./image');

let _internals = {
    lastScrollY: 0,
    initYMaps: function () {
        let el = document.getElementById('map');

        if (!el) {
            return;
        }

        _internals.observeCallback('map', _internals.initYMMapsInternal);
    },
    initYMMapsInternal: function () {
        let r = false;

        let s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;

        let lang = 'ru_RU';

        if (document.body.getAttribute('data-locale') === 'en') {
            lang = 'en_US';
        }

        s.src = 'https://api-maps.yandex.ru/2.1/?lang=' + lang;
        let ss = document.getElementsByTagName('script')[0];
        ss.parentNode.insertBefore(s, ss);

        s.onload = s.onreadystatechange = function () {
            if (!r && (!this.readyState || this.readyState === 'complete')) {
                window.ymaps.ready(function () {
                    let map = new window.ymaps.Map("map", {
                        center: [60.046937, 30.339221],
                        zoom: 16,
                        controls: ["zoomControl"]
                    });
                    let myPlacemark = new window.ymaps.Placemark([60.046937, 30.339221], {}, {
                        iconLayout: 'default#image',
                        iconImageHref: '/assets/img/point.png',
                        iconImageSize: [48, 48]
                    });

                    map.geoObjects.add(myPlacemark);
                    if (_internals.mobileAndTabletCheck()) {
                        map.behaviors.disable('drag');
                    }

                    map.behaviors.disable('scrollZoom');
                });
            }
        }
    },
    mobileAndTabletCheck: function () {
        let check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    },
    initMobileMenu: function () {
        let menuOpener = document.getElementById('menuOpener');
        let menuCloser = document.getElementById('menuCloser');
        let navbar = document.getElementById('main-menu');
        let body = document.body;

        menuOpener.addEventListener('click', function () {
            body.classList.add('menu_open');
            navbar.classList.remove('slideOutLeft');
            navbar.classList.add('animated', 'slideInLeft');
        });

        menuCloser.addEventListener('click', function () {
            body.classList.remove('menu_open');
            navbar.classList.remove('slideInLeft');
            navbar.classList.add('slideOutLeft')
        });
    },
    observeSlider: function (element, slider) {
        _internals.observeCallback(element, function () {
            slider.init();
        });
    },
    observeCallback: function (element, callback) {
        if (!('IntersectionObserver' in window)) {
            callback();
        } else {
            let observer = new IntersectionObserver(function (entries, observer) {
                for (let i = 0; i < entries.length; i++) {
                    if (entries[i].intersectionRatio > 0) {
                        callback();
                        observer.disconnect();
                    }
                }
            }, {
                rootMargin: '10px 0px',
                threshold: 0.01
            });
            observer.observe(document.getElementById(element));
        }
    },
    serialize: function (form) {
        // Setup our serialized data
        let serialized = [];

        // Loop through each field in the form
        for (let i = 0; i < form.elements.length; i++) {

            let field = form.elements[i];

            // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
            if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

            // If a multi-select, get all selections
            if (field.type === 'select-multiple') {
                for (let n = 0; n < field.options.length; n++) {
                    if (!field.options[n].selected) continue;
                    serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
                }
            }

            // Convert field data to a query string
            else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
                serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
            }
        }

        return serialized.join('&');
    },
    submitForm: function (form) {
        let submitButton = form.querySelector('button[type=submit]');

        let disabled = submitButton.getAttribute('disabled');

        if (disabled === 'disabled') {
            return Promise.resolve();
        }

        submitButton.setAttribute('disabled', 'disabled');

        let uri = form.getAttribute('action');

        return axios({
            url: uri,
            method: 'post',
            data: _internals.serialize(form)
        }).then(function (response) {
            return Promise.resolve(response.data);
        }).catch(function (e) {
            submitButton.removeAttribute('disabled');
            if (e.response) {
                if (e.response.status === 422) {
                    _internals.renderFormErrors(form, e.response.data);
                    return Promise.reject(new Error("Form submission failed, Data: " + JSON.stringify(e)));
                } else {
                    return Promise.reject(new Error("Form submission failed, Code: " + e.response.status));
                }
            }
            return Promise.reject(new Error("Form submission failed: " + e.message));
        })
    },
    renderFormErrors: function (form, data) {
        let container = form.querySelector('.form-errors');
        container.classList.remove('hidden');
        container.innerHTML = '';
        for (let field in data) {
            container.innerHTML += `<div class="alert alert-danger">${data[field]}</div>`;
        }
    },
    initTracking: function () {
        import(/* webpackChunkName: "tracking" */ './tracking').then(function (tracking) {
            tracking.init();
        }, function (e) {
            console.log('Unable to load tracking script: ' + e);
        });
    },
    initHeader: function () {
        let header = document.getElementById('header');

        //Стиль шапки при скролле
        window.addEventListener('scroll', debounce(_internals.checkHeader, 30));
    },
    checkHeader: function () {
        let header = document.querySelector('header');

        let scroll = window.scrollY !== undefined ? window.scrollY : window.pageYOffset;

        if (scroll > 100){
            header.classList.add('header_sticky');
        } else {
            header.classList.remove('header_sticky');
        }

        if (_internals.lastScrollY < scroll) {
            header.classList.remove('header_sticky_active');
        } else {
            header.classList.add('header_sticky_active');
        }

        _internals.lastScrollY = scroll;
    }
};

_internals.initTracking();
_internals.initYMaps();
_internals.initMobileMenu();
_internals.initHeader();
modals.init();
LazyLoad.init();


export const observeSlider = _internals.observeSlider;
export const submitForm = _internals.submitForm;